module.exports = __webpack_public_path__ + "c5d109be8edd3de0f60eb472bd9ef691.svg";